import {useCallback} from 'react';

import {USER_REDIRECTION_EVENTS} from '@/app/auth/events/UserRedirectionEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';
import {PlatformType} from '@/services';

export const useParentRedirectionTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewParentRedirection = useCallback(() => {
    trackEvent(USER_REDIRECTION_EVENTS.VIEW_REDIRECTION_PAGE, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  const trackSelectDownloadApp = useCallback(
    (platform: PlatformType) => {
      trackEvent(USER_REDIRECTION_EVENTS.SELECT_DOWNLOAD_APP, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        origin: platform,
      });
    },
    [trackEvent],
  );

  return {
    trackViewParentRedirection,
    trackSelectDownloadApp,
  };
};
